"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Shimmer = _interopRequireDefault(require("../Shimmer"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _shimmerCarousel = _interopRequireDefault(require("./shimmerCarousel.proptypes"));

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ScrollBehavior = (0, _styledComponents.css)(["scroll-behavior:smooth;::-webkit-scrollbar{display:none;}-ms-overflow-style:none;scrollbar-width:none;-webkit-overflow-scrolling:touch;scroll-snap-type:x mandatory;-ms-scroll-snap-type:x mandatory;-webkit-scroll-snap-type:x mandatory;"]);

var ShimmerCarouselContainer = _styledComponents.default.div.withConfig({
  displayName: "ShimmerCarousel__ShimmerCarouselContainer",
  componentId: "sc-1e7pica-0"
})(["display:grid;grid-template-columns:repeat(12,calc(100% / 12));grid-auto-columns:calc(100% / 12);grid-auto-flow:column;overflow:auto;@media screen and (max-width:", "){grid-template-columns:repeat(4,calc(100% / 4));grid-auto-columns:calc(100% / 4);overflow:scroll;}@media screen and (min-width:", "){grid-template-columns:repeat(8,calc(100% / 8));grid-auto-columns:calc(100% / 8);}@media screen and (min-width:", "){grid-template-columns:repeat(8,calc(100% / 8));grid-auto-columns:calc(100% / 8);}@media screen and (min-width:", "){grid-template-columns:repeat(12,calc(100% / 12));grid-auto-columns:calc(100% / 12);}", ";"], _constant.BREAKPOINTS.MOBILE, _constant.BREAKPOINTS.SMALL_TABLET, _constant.BREAKPOINTS.MEDIUM_TABLET, _constant.BREAKPOINTS.LARGE_TABLET, ScrollBehavior);

var ShimmerCarouselGrid = _styledComponents.default.div.withConfig({
  displayName: "ShimmerCarousel__ShimmerCarouselGrid",
  componentId: "sc-1e7pica-1"
})(["grid-column:span 3;scroll-snap-align:start;"]);

var ShimmerCarouselCard = _styledComponents.default.div.withConfig({
  displayName: "ShimmerCarousel__ShimmerCarouselCard",
  componentId: "sc-1e7pica-2"
})(["background-color:", ";margin:", ";padding:", ";border:1px solid ", ";border-radius:", ";box-shadow:0px 1px 2px rgba(0,0,0,0.08);.shimmer-carousel:not(:last-child){margin-bottom:", ";}"], function (props) {
  return props.theme.colors.default;
}, function (props) {
  return props.theme.space.micro;
}, function (props) {
  return props.theme.space.small;
}, function (props) {
  return props.theme.colors.greyLight;
}, function (props) {
  return props.borderRadius;
}, function (props) {
  return props.theme.space.tiny;
});

var ShimmerCarousel = function ShimmerCarousel(props) {
  var cards = props.cards,
      borderRadius = props.borderRadius,
      theme = props.theme,
      accessible = props.accessible,
      customProperties = props.customProperties;
  var shimmerCards = [];
  var shimmerCustomProps = {
    className: 'shimmer-carousel'
  };
  var shimmerOtherProps = {
    accessible: false,
    customProperties: shimmerCustomProps
  };
  var tabIndex = !accessible ? '-1' : '0'; // eslint-disable-next-line no-plusplus

  for (var i = 0; i < cards; i++) {
    shimmerCards.push( /*#__PURE__*/_react.default.createElement(ShimmerCarouselGrid, {
      key: "shimmer-carousel-card-".concat(i)
    }, /*#__PURE__*/_react.default.createElement(ShimmerCarouselCard, {
      borderRadius: borderRadius
    }, /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({
      width: "48%"
    }, shimmerOtherProps)), /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({
      width: "95%"
    }, shimmerOtherProps)), /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({
      width: "30%"
    }, shimmerOtherProps)), /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({
      width: "44%"
    }, shimmerOtherProps)))));
  }

  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(ShimmerCarouselContainer, (0, _extends2.default)({
    tabIndex: tabIndex
  }, customProperties), shimmerCards));
};

ShimmerCarousel.propTypes = _shimmerCarousel.default.PropTypes;
ShimmerCarousel.defaultProps = _shimmerCarousel.default.DefaultProps;
var _default = ShimmerCarousel;
exports.default = _default;